
import Vue from "vue";
import AppPricing from "@/components/account/Pricing.vue";

export default Vue.extend({
	components: {
		AppPricing,
	}
});
